// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__xuYDP","overflowing":"ReadFullNote_overflowing__1F6Is"};